import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const MotivatorIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 20 20"
      data-fill-none
    >
      <path
        d="M17.6916 14.6977C17.6916 14.6977 16.2705 11.536 12.7716 11.4482C10.5848 11.3934 6.61325 12.7004 6.57013 14.4186L5.9655 7.36999C5.9655 7.36999 7.26369 8.20875 8.9329 7.23692"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4018 18.7692L3.34374 18.4165C2.48464 18.3949 1.79954 17.6675 1.82131 16.8L3.25997 6.1822C3.3539 5.55322 3.60205 5.00702 3.92633 4.54166L9.17001 1.12196C9.48835 0.893194 9.87687 0.981859 10.1052 1.22434L11.2471 2.43675C11.858 3.0045 12.1506 3.80102 12.0508 4.6666C12.031 5.45527 11.6207 6.23415 10.982 6.77055L10.5035 7.15313C10.025 7.53571 9.32212 7.51807 8.86143 7.19084C8.24652 6.78083 8.11209 5.90936 8.59652 5.29017"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
